module.exports = __webpack_public_path__ + "img/beta-launch.2db27c35.png";